import styled from 'styled-components'

export const Container = styled.div`
  // ⚠️ DO NOT ADD STYLE HERE UNLESS IT IS COMMON TO ALL THE COMPONENTS USING RICHTEXT
  & a {
    color: inherit;
    text-decoration: underline;
    &:hover,
    &:focus {
      text-decoration: none;
    }
  }
`
